"use strict";
exports.__esModule = true;
exports.chart_donut_threshold_dynamic_pie_Width = {
  "name": "--pf-chart-donut--threshold--dynamic--pie--Width",
  "value": 202,
  "var": "var(--pf-chart-donut--threshold--dynamic--pie--Width, 202)"
};
exports["default"] = exports.chart_donut_threshold_dynamic_pie_Width;